import { atom } from "jotai";
import type {
  ListOverlaysQuery,
  Overlay,
  OverlayCategory,
  OverlayLicense,
  OverlayModerationStatus,
} from "../types";

export const overlayStatusFilterAtom = atom<OverlayModerationStatus>("pending");
export const overlayCategoryFilterAtom = atom<OverlayCategory | "all">("all");
export const overlayLicenseFilterAtom = atom<OverlayLicense | "all">("all");
export const overlaySearchAtom = atom<string>("");
export const overlayPageAtom = atom<number>(1);

export const selectedOverlayAtom = atom<Overlay | null>(null);

export const overlayFiltersAtom = atom<ListOverlaysQuery>((get) => {
  const category = get(overlayCategoryFilterAtom);
  const license = get(overlayLicenseFilterAtom);
  const search = get(overlaySearchAtom).trim();

  const query: ListOverlaysQuery = {
    status: get(overlayStatusFilterAtom),
    page: get(overlayPageAtom),
    limit: 20,
  };

  if (category !== "all") query.category = category;
  if (license !== "all") query.license = license;
  if (search) query.search = search;

  return query;
});
